import { queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type { CreditSettingsDto } from './model';

export const videoCredis = queryOptions({
  queryKey: ['信用点配置', '视频'],
  queryFn: () => {
    return http.get<CreditSettingsDto>('credit-settings/video').json();
  },
});

export const imageCredis = queryOptions({
  queryKey: ['信用点配置', '图片'],
  queryFn: () => {
    return http.get<CreditSettingsDto>('credit-settings/image').json();
  },
});
